export default __webpack_public_path__ + "static/buying-property-d-900a25e1b1e9c3213ebb0855b5665f6c.png";